import React, { useState, useEffect } from "react";

import { func_validation, func_url } from "functions";


/*
    ***Required Props***

    login: () => {},
    isLoggedIn: boolean,
    login_errorMsg: String,
    urlRedirection_afterLogin: String,
*/

export function useLogin(props) {
	const { userInfo } = props;
	const recaptchaObj = props.recaptchaObj;

	// States

	const [email, setEmail] = useState("");
	const [isEmailValid, setEmailValidity] = useState();
	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");
	const [rememberMe, setRememberMe] = useState(false);

	const [isFormSubmissionAttempted, setFormSubmissionAttempted] = useState(false);

	// Submit
	async function handleSubmit() {
		setFormSubmissionAttempted(true);

		if (email && isEmailValid && password) {
			const recaptchaToken = await recaptchaObj.execute('login');
			onResolved(recaptchaToken); 
		}
	}

	// Recaptch Resolved
	function onResolved(recaptchaToken) {
		if (email && isEmailValid && password) {
			let loginObj = {
				"username": email,
				"password": password,
				"recaptcha": recaptchaToken
			}

			if (props.login) props.login(loginObj);
		}
	}

	// Mounted
	useEffect(() => {
		const { authorized_urlRedirection, userInfo, refreshTokenCookieName } = props;

		if (func_validation.isRefreshTokenValid(refreshTokenCookieName)) {
			if (func_validation.isObjectNotEmpty(userInfo)) {
				// Redirect to login page
				if (props.urlRedirectValidation) {
					if (props.urlRedirectValidation()) 
						func_url.historyPushToURL(props, authorized_urlRedirection);
				}
				else func_url.historyPushToURL(props, authorized_urlRedirection);
			}
			else if (props.getUserInfo) {
				props.getUserInfo();
			}
		}
	}, [userInfo]);

    // After Login
	const [isAlertMsgVisible, alertMsg, setIsAlertMsgVisible] = useAfterLoginHandler(props, isEmailValid, email, password);

    return {
        email, setEmail,
        isEmailValid, setEmailValidity,
        username, setUsername,
        password, setPassword,
        rememberMe, setRememberMe,
        isFormSubmissionAttempted,

        handleSubmit,

        isAlertMsgVisible, alertMsg, setIsAlertMsgVisible
    }
}


function useAfterLoginHandler(props, isEmailValid, email, password) {
	const { isLoggedIn, login_errorMsg, userInfo } = props;

	const [isAlertMsgVisible, setIsAlertMsgVisible] = useState(false);
	const [alertMsg, setAlertMsg] = useState("");
	const [isMounted, setIsMounted] = useState(false);

	useEffect(() => {
		if (isMounted) {
			if (func_validation.isBooleanTrueNotNullUndefined(isLoggedIn) &&
				func_validation.isObjectNotEmpty(userInfo) &&
				props.handleOnSuccess) {
				// recaptcha.reset();
				props.handleOnSuccess(userInfo);
			}
			else if (func_validation.isBooleanTrueNotNullUndefined(isLoggedIn) &&
				props.getUserInfo) {
				props.getUserInfo();
			}
			else if (func_validation.isBooleanFalseNotNullUndefined(isLoggedIn) &&
				func_validation.isNotNullUndefined(login_errorMsg)) {

				let login_errorMsg_formatted = func_validation.isStringTrimNotEmpty(login_errorMsg) ? login_errorMsg : "Failed to login";
				setAlertMsg(login_errorMsg_formatted);
				setIsAlertMsgVisible(true);
			}
		}
		else setIsMounted(true);
	}, [isLoggedIn, userInfo]);

	return [isAlertMsgVisible, alertMsg, setIsAlertMsgVisible];
}